/** @fileoverview Sends a visitor on the apps domain to the builder hand-over page found from the hostname. */

import { useEffect } from 'react';
import { createStoredCheck } from './appCheck';
import { getCurrentBuilderUrl } from './hostConfig';

type Props = {
  address: string;
};

/** Saves a new check value, then redirects to the builder hand-over page. */
export default function RedirectToHandover({ address }: Props) {
  const builderUrl = getCurrentBuilderUrl();

  useEffect(() => {
    if (builderUrl) {
      const check = createStoredCheck();
      window.location.replace(
        `${builderUrl}/app-handover?app=${encodeURIComponent(address)}&check=${encodeURIComponent(
          check
        )}`
      );
    }
  }, [address, builderUrl]);

  return (
    <main className="flex min-h-screen items-center justify-center p-6 text-center text-sm text-app-text-muted">
      {builderUrl
        ? 'Signing you in…'
        : 'This app cannot be opened because the Fabrik address could not be worked out from this address.'}
    </main>
  );
}
